var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownSuffix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5816 9.58161C9.02375 10.1395 8.11917 10.1395 7.56131 9.58161L0.418416 2.43874C-0.139472 1.88084 -0.139472 0.976318 0.418416 0.418416C0.976318 -0.139472 1.88083 -0.139472 2.43874 0.418416L8.57146 6.55117L14.7042 0.418416C15.2621 -0.139472 16.1666 -0.139472 16.7245 0.418416C17.2823 0.976318 17.2823 1.88084 16.7245 2.43874L9.5816 9.58161Z",
    fill: "#8996A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownSuffix);
export default __webpack_public_path__ + "static/media/dropdownSuffix.e863dd5692caed77f280b782f3ee2a52.svg";
export { ForwardRef as ReactComponent };